<template>
  <div class="doc-viewer-page" v-if="src">
    <pdf v-for="i in numPages" :key="`pdf-${src.docId}-page-${i}`" :src="src" :page="i" />
  </div>
</template>

<script>
import _ from 'lodash'
import pdf from 'vue-pdf'

export default {
  name: 'DocViewer',
  props: ['docUrl'],
  data() {
    return {
      url: _.get(this.$route, 'query.docUrl', ''),
      src: null,
      numPages: null,
    }
  },
  computed: {
    loadingTask() {
      return pdf.createLoadingTask(this.url)
    },
  },
  components: { pdf },
  created() {
    this.src = this.loadingTask

    this.src.then(pdf => {
      this.numPages = pdf.numPages
    })
  },
}
</script>

<style lang="scss">
.doc-viewer-page {
  margin: 0 auto;
  width: 90%;
}
</style>
